import logo from "./logo.svg";
import "./App.css";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "./Loader";
import Popup from "./Popup";

function MarkAttendance() {
  let params = useParams();
  const [userData, setUserData] = useState(null);
  const [Text, setText] = useState(null);
  const [loader, setLoader] = useState(false);
  const [flag, setFlag] = useState("");
  const [checkin, setCheckin] = useState(false);
  useEffect(() => {
    try {
      let obj = {};
      window.gtag("event", `attendance_page_viewed`, obj);
    } catch (error) {}
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append(
      "Cookie",
      "ak_bmsc=34FA2C369CC56B4EE9357FC031BE8D4E~000000000000000000000000000000~YAAQrfY3F9QgOTaOAQAAdhEygBczKG2nM4fZPUGNl0/znGa28Y9XxfrqF2u2GIpQOkyNBWxmvZb9ONfoY2H5kTDHqZPqwrL70VgwZJ4spkFlsZq+vCXYTqhbz4po/JsMqz5v7C0PYeEJPKbJ3QjxF8qiSklzgmsKz2t0GKXOyCHr6rP39vIG+yjFW3+8d86SQLbvHuu12iqSZRkmgiTzu8CbH1ndgaR0FSfpxvZGDC83YaTim05/ZnqWF5nk85r9gSh7I2kUQVH8X8yztvWLLkQ8d956oAtjUd8wGGgCd5iUlBJUtpkiK5uQHR179rHcUFrXm69saxyf5e4+1ZN24FCvFoguJzgpK0x/o+GxlCYLM5GdKz+sqMu8/rYuPeKiQg==; bm_sv=6CDDF04250C3F57D2983C672B618B104~YAAQrfY3F/nmOTaOAQAAOY5RgBdgjQpmVhqRZIDH3Tx01Hes6vRVJMLtPHc8B55z/Mq6pNbH+dza0gigo0u0Sb7miklMMRPjCJdaTbb0Kfbv2HgLfzUWJGai8QpEpqWv1lm287sSRM3M7xhWVakK582NwSNAVJtQKsqU68zAg6b7wk4IgYI2pRBxNeU6ncrmOIH2AGWPtlhR6iL/aTL3AA02ZIa8IhMqMLxk+qN37nmOW8Bzxm89RCASM+s+Chtlw+FqmsE=~1; ADRUM_BT=R%3A0%7Cg%3Abef6ea53-2a70-4566-88fe-062ecf696cec4005%7Cn%3Atmp_bjp_fb49d1de-d391-478a-ab5f-c84d7b25602e%7Ci%3A37735%7Cd%3A13%7Ce%3A107; NSC_10.10.24.75_443=ffffffff0902066345525d5f4f58455e445a4a423660"
    );

    const formdata = new FormData();
    formdata.append("index", "0");
    // formdata.append("eventid", "65fc4447dbe698309b6b3df9"); // bihar state event id
    formdata.append("eventid", "6791c66b5e9b922d95078c4f"); //haryana state event id
    formdata.append("userid", params.id);
    formdata.append("action", "eventjoinuserlist");
    formdata.append("pagesize", "1");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch("https://api.narendramodi.in/mlapiv1", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result && result._resultflag == 1) {
          let list = result.eventparticipantslist;
          if (list && list.length > 0) {
            let obj = list[0];

            setUserData(obj);
            setCheckin(obj.attendence == 1 ? true : false);
            setFlag(obj.attendence);
            setLoader(false);
          }
        }
      })
      .catch((error) => console.error(error));
  }, [params.id]);

  // console.log(userData);

  const setCheckInFn = () => {
    if (flag == 1) {
      setCheckin(true);
      return;
    }
    try {
      let obj = {};
      window.gtag("event", `check_in_clicked`, obj);
    } catch (error) {}
    let id = params.id;
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append(
      "Cookie",
      "ak_bmsc=34FA2C369CC56B4EE9357FC031BE8D4E~000000000000000000000000000000~YAAQrfY3F9QgOTaOAQAAdhEygBczKG2nM4fZPUGNl0/znGa28Y9XxfrqF2u2GIpQOkyNBWxmvZb9ONfoY2H5kTDHqZPqwrL70VgwZJ4spkFlsZq+vCXYTqhbz4po/JsMqz5v7C0PYeEJPKbJ3QjxF8qiSklzgmsKz2t0GKXOyCHr6rP39vIG+yjFW3+8d86SQLbvHuu12iqSZRkmgiTzu8CbH1ndgaR0FSfpxvZGDC83YaTim05/ZnqWF5nk85r9gSh7I2kUQVH8X8yztvWLLkQ8d956oAtjUd8wGGgCd5iUlBJUtpkiK5uQHR179rHcUFrXm69saxyf5e4+1ZN24FCvFoguJzgpK0x/o+GxlCYLM5GdKz+sqMu8/rYuPeKiQg==; bm_sv=6CDDF04250C3F57D2983C672B618B104~YAAQrfY3F/nmOTaOAQAAOY5RgBdgjQpmVhqRZIDH3Tx01Hes6vRVJMLtPHc8B55z/Mq6pNbH+dza0gigo0u0Sb7miklMMRPjCJdaTbb0Kfbv2HgLfzUWJGai8QpEpqWv1lm287sSRM3M7xhWVakK582NwSNAVJtQKsqU68zAg6b7wk4IgYI2pRBxNeU6ncrmOIH2AGWPtlhR6iL/aTL3AA02ZIa8IhMqMLxk+qN37nmOW8Bzxm89RCASM+s+Chtlw+FqmsE=~1; ADRUM_BT=R%3A0%7Cg%3Abef6ea53-2a70-4566-88fe-062ecf696cec4005%7Cn%3Atmp_bjp_fb49d1de-d391-478a-ab5f-c84d7b25602e%7Ci%3A37735%7Cd%3A13%7Ce%3A107; NSC_10.10.24.75_443=ffffffff0902066345525d5f4f58455e445a4a423660"
    );

    const formdata = new FormData();
    // formdata.append("eventid", "65fc4447dbe698309b6b3df9"); //bihar state eventid
    formdata.append("eventid", "6791c66b5e9b922d95078c4f"); // haryana state event id
    formdata.append("action", "joinattendence");
    formdata.append("userid", id);
    formdata.append("attendence", "1");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch("https://api.narendramodi.in/mlapiv1", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result && result._resultflag == 1) {
          // let list = result.eventparticipantslist;
          // if (list && list.length > 0) {
          //   let obj = list[0];

          // setUserData(obj);
          setCheckin(true);
          setText("Event attendence  marked successfully");
          setLoader(false);
          // }
        }
      })
      .catch((error) => console.error(error));
  };

  const popupClose = () => {
    setCheckin(false);
  };
  return (
    <>
      {loader && <Loader />}
      {checkin && <Popup text={Text} popupClose={popupClose} />}
      <div className="tiffin_container">
        <div className="tiifin_header">
          <img src="./images/bjplogo.png" className="bjplogo" alt="" />
          <h4 className="modi_head">मोदी का परिवार टिफ़िन बैठक</h4>
          <img
            src={
              userData?.avatar
                ? userData.avatar
                : "https://nm-seva-photos.b-cdn.net/userdefault.jpg"
            }
            className="user_img"
            alt=""
          />
        </div>

        <div className="tifficn_bg">
          <div className="user_detail">
            <h3>{userData?.name}</h3>
            <h5>
              {userData?.mandal}, {userData?.vidhansabha}
            </h5>
          </div>
          {/* <img src="./images/barcode.png" className="bar_code" alt="" /> */}
          <button
            className="bar_code"
            onClick={() => {
              setCheckInFn();
            }}
          >
            Check-In
          </button>
          {/* <button></button> */}
          {/* <img src="./images/modiji.png" className="modiji_img" alt="" /> */}
        </div>
      </div>
    </>
  );
}

export default MarkAttendance;
